import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

when($('helptab'), el => {
   let tabInit = function () {
      setHelpTabTransition(el, 'duration-500');
      el.style.right = '-95px';
   };

   tabInit.delay(1000);
   el.addEvents({
      mouseenter: function () {
         setHelpTabTransition(el, 'duration-200');
         el.style.right = '-40px';
      },
      mouseleave: function () {
         setHelpTabTransition(el, 'duration-200');
         el.style.right = '-95px';
      },
      click: function () {
         trackAnalyticsCustomEvent({
            eventCategory: 'Help Tab',
            eventAction: 'Click',
         });
         return true;
      },
   });
});

function setHelpTabTransition(el, durationClass) {
   el.classList.remove('duration-200', 'duration-500');
   el.classList.add('transition-all', 'ease-out', durationClass);
}
